module.exports = __webpack_public_path__ + "media/images/emblems/Rapperswil-coat_of_arms-24ac36e33c2b51fe69491c7ae575b057.svg";